import ApiService from '@/common/api.service'
import * as action from '@/store/action.types'
import {
  GET_BANK_ACCOUNTS_URL,
  ADD_CUSTOMER_URL,
  EDIT_CUSTOMER_URL,
  RETRY_CUSTOMER_URL,
  UPLOAD_DOCUMENT_URL,
  GET_BANK_INSTITUTIONS_URL,
  GET_CLIENT_TOKEN_URL,
  BRAINTREE_ADD_URL,
  BRAINTREE_UPDATE_URL,
  BRAINTREE_RETRY_PAYMENT_URL,
  GET_SUBSCRIPTIONS_URL,
  CANCEL_SUBSCRIPTION_URL,
  DELETE_SUBSCRIPTION_CARD_URL,
  DELETE_CHECKBOOK_ACCOUNT_URL,
  DEFAULT_CHECKBOOK_ACCOUNT_URL,
  CHECKBOOK_LOGIN_TO_BANK_URL,
  CHECKBOOK_ADD_BANK_ACCOUNT_URL,
  CHECKBOOK_ADD_MFA_ANSWER_URL,
  CHECKBOOK_ADD_MD_AMOUNTS_URL,
  GET_PLAID_LINK_TOKEN_URL,
} from '@/constants/ApiConstants'
import { ADD_REFERRAL_CODE_URL, GET_BANK_ACCOUNT_WITH_PLAID_URL, GET_PLAID_ACCOUNT_PROCESSOR_TOKEN_URL } from '../../constants/ApiConstants'

const state = {}

const getters = {}

const actions = {
  [action.GET_BANK_ACCOUNTS]() {
    return ApiService.get(GET_BANK_ACCOUNTS_URL);
  },
  [action.ADD_CUSTOMER](_, data) {
    return ApiService.post(ADD_CUSTOMER_URL, data);
  },
  [action.EDIT_CUSTOMER](_, data) {
    return ApiService.putData(EDIT_CUSTOMER_URL, data);
  },
  [action.RETRY_CUSTOMER](_, data) {
    return ApiService.post(RETRY_CUSTOMER_URL, data);
  },
  [action.UPLOAD_DOCUMENT](_, data) {
    return ApiService.post(UPLOAD_DOCUMENT_URL, data);
  },
  [action.GET_BANK_INSTITUTIONS]() {
    return ApiService.get(GET_BANK_INSTITUTIONS_URL);
  },
    [action.GET_CLIENT_TOKEN]() {
      return ApiService.get(GET_CLIENT_TOKEN_URL);
    },
  [action.BRAINTREE_ADD](_, data) {
    return ApiService.post(BRAINTREE_ADD_URL, data);
  },
  [action.ADD_REFERRAL_CODE](_, data) {
    return ApiService.post(ADD_REFERRAL_CODE_URL, data);
  },
  [action.BRAINTREE_UPDATE](_, data) {
    return ApiService.putData(BRAINTREE_UPDATE_URL.replace(':creditCardToken', data.creditCardToken));
  },
  [action.BRAINTREE_RETRY_PAYMENT]() {
    return ApiService.get(BRAINTREE_RETRY_PAYMENT_URL);
  },
  [action.GET_SUBSCRIPTIONS]() {
    return ApiService.get(GET_SUBSCRIPTIONS_URL);
  },
  [action.CANCEL_SUBSCRIPTION]() {
    return ApiService.get(CANCEL_SUBSCRIPTION_URL);
  },
  [action.DELETE_SUBSCRIPTION_CARD](_, data) {
    return ApiService.delete(DELETE_SUBSCRIPTION_CARD_URL.replace(':creditCardToken', data.creditCardToken));
  },
  [action.DELETE_CHECKBOOK_ACCOUNT](_, data) {
    return ApiService.delete(DELETE_CHECKBOOK_ACCOUNT_URL.replace(':bankId', data.bankId));
  },
  [action.DEFAULT_CHECKBOOK_ACCOUNT](_, data) {
    return ApiService.putData(DEFAULT_CHECKBOOK_ACCOUNT_URL.replace(':bankId', data));
  },
  [action.CHECKBOOK_LOGIN_TO_BANK](_, data) {
    return ApiService.post(CHECKBOOK_LOGIN_TO_BANK_URL.replace(':institutionId', data.institutionId), data);
  },
  [action.CHECKBOOK_ADD_BANK_ACCOUNT](_, data) {
    return ApiService.post(CHECKBOOK_ADD_BANK_ACCOUNT_URL, data);
  },
  [action.CHECKBOOK_ADD_MFA_ANSWER](_, data) {
    return ApiService.post(CHECKBOOK_ADD_MFA_ANSWER_URL.replace(':institutionId', data.institutionId), data);
  },
  [action.CHECKBOOK_ADD_MD_AMOUNTS](_, data) {
    return ApiService.post(CHECKBOOK_ADD_MD_AMOUNTS_URL.replace(':institutionId', data.institutionId), data);
  },
  [action.GET_PLAID_LINK_TOKEN](){
    return ApiService.get(GET_PLAID_LINK_TOKEN_URL);
  },
  [action.GET_PLAID_ACCOUNT_PROCESSOR_TOKEN](_metaArgs,data){
    return ApiService.post(GET_PLAID_ACCOUNT_PROCESSOR_TOKEN_URL,data);
  },
  [action.GET_BANK_ACCOUNT_WITH_PLAID](_metaArgs,data){
    return ApiService.post(GET_BANK_ACCOUNT_WITH_PLAID_URL,data);
  },

};

export default {
  state,
  actions,
  getters
}